export default "__VITE_ASSET__RkfiZKrN__"